// extracted by mini-css-extract-plugin
var _1 = "decor__wycET";
var _2 = "item__lo3Rn";
var _3 = "moneyStepsWrapper__je_8_";
var _4 = "titleWrapper__xDdAm";
export { _1 as "decor", _2 as "item", _3 as "moneyStepsWrapper", _4 as "titleWrapper" }
export default { "decor": _1, "item": _2, "moneyStepsWrapper": _3, "titleWrapper": _4 }
